import * as React from 'react';

// noinspection ES6ConvertVarToLetConst
import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import { connect } from 'react-redux'
import { selectors as lifcycleSelectors, SyncLifecycleValues } from '../../lifecycle/lifecycle'
import { AppState, Dispatch } from '../../types'
import { AccessDeniedSvg } from './AccessDeniedSvg'
import VisualizerApi from '../../util/VisualizerApi'
import { Labels } from '../../common/labels/model'
import { changeEmptyState } from '../EmptyStatePage/actions'

type ValueProps = {
  syncInitializationState: SyncLifecycleValues,
  syncInitializationError: string
  labels?: Labels
}

type EventProps = {
  changeEmptyState: (errorStatusCode: number) => void
}

export type Props = ValueProps & EventProps

class SyncChecker extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props)
    
    this.saveLabels = this.saveLabels.bind(this)
    this.emptyState = this.emptyState.bind(this)
  }
  
  componentDidMount() {
    VisualizerApi.addMessageEventListener('fetch-labels', this.saveLabels)
    VisualizerApi.addMessageEventListener('empty-state', this.emptyState)
  }
  
  componentWillUnmount() {
    VisualizerApi.removeMessageEventListener('fetch-labels')
    VisualizerApi.removeMessageEventListener('empty-state')
  }
  
  saveLabels() {
    const labels = this.props.labels
    if (labels) {
      VisualizerApi.saveLabels(labels)
    }
  }
  
  emptyState(errorStatusCode?: number) {
    if (errorStatusCode) {
      this.props.changeEmptyState(errorStatusCode)
    }
  }
  
  componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
    if (nextProps.labels) {
      VisualizerApi.saveLabels(nextProps.labels)
    }
  }

  render() {
    const {syncInitializationState, syncInitializationError, children} = this.props;

    switch (syncInitializationState) {
      case SyncLifecycleValues.InitializingSync:
        return (
          <div className="app-loading">
            <Spinner size="m"/>
          </div>
        );
      case SyncLifecycleValues.InitializedSyncError:
        if (
            syncInitializationError === 'Forbidden - User doesn\'t have permission to access'
            || syncInitializationError === 'Not allowed - User doesn\'t have permission to access'
        ) {
          return (
            <div className="app-error">
              <p>You don’t have permission to access Anypoint Monitoring.</p>
              <p>
                Ask your administrator to grant you the Anypoint Monitoring User permission.
              </p>
              <AccessDeniedSvg/>
            </div>
          );
        } else {
          return children
        }
      case SyncLifecycleValues.InitializedSync:
      default:
        return children
    }
  }
}

const mapState = (rootState: AppState): ValueProps => ({
  syncInitializationState: lifcycleSelectors.getSyncInitializationState(rootState),
  syncInitializationError: lifcycleSelectors.getSyncInitializationError(rootState),
  labels: rootState.monitoring.labels.resources
});

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  changeEmptyState: (errorStatusCode: number) => dispatch(changeEmptyState(errorStatusCode))
})

export default connect(mapState, mapDispatchToProps)(SyncChecker);
